import { render, staticRenderFns } from "./Valitador.vue?vue&type=template&id=6c0a604c&"
import script from "./Valitador.vue?vue&type=script&lang=js&"
export * from "./Valitador.vue?vue&type=script&lang=js&"
import style0 from "./Valitador.vue?vue&type=style&index=0&id=6c0a604c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports